'use client';

import { AppImageClient, AppImageData } from '@components/appImage';
import { Card } from '@components/card';
import { classNames } from '@lib/classNames/classNames';

import { KeyFeature } from '../types';

type Props = {
  features: (KeyFeature & {
    imageDataLg: AppImageData;
    imageDataSm: AppImageData;
  })[];
};

export const KeyFeaturesMobileSection = ({ features }: Props) => {
  return (
    <div className="flex flex-col gap-4 px-4 md:hidden">
      {features.map((card) => (
        <div
          key={card.id}
          className={classNames({
            cls: '',
            mods: {
              [`col-span-${card.gridSpan}`]: true,
            },
          })}
        >
          <Card rounded="24">
            <div className="p-7 max-sm:p-5">
              <div className="flex flex-col justify-between gap-[30px]">
                <div>
                  {/** Заголовок */}
                  <h4 className="pb-3 text-[24px] leading-[32px] font-medium">
                    {card.title}
                  </h4>
                  {/** Описание */}
                  <p className="pb-4 text-[16px] leading-[24px]">
                    {card.description}
                  </p>
                  {/** Список кейсов (может быть несколько, до 5 шт) */}
                  <ul className="space-y-2">
                    {card.useCases.map((useCase, index) => (
                      <li
                        key={index}
                        className="flex items-start gap-3 text-[14px] leading-[20px]"
                      >
                        <span className="mt-1 size-3 shrink-0 rounded-full bg-[#3BB643]" />
                        <span>{useCase}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/** Блок с картинкой */}
                <div>
                  <AppImageClient {...card.imageDataSm} alt={card.title} />
                </div>
              </div>
            </div>
          </Card>
        </div>
      ))}
    </div>
  );
};
